import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { CompareIndustry } from './CompareIndustry'
import { DefaultIndustry } from './DefaultIndustry'

export const LeftFilter = () => {
  const { companyType } = useSelector(selectCompanyInfo)
  const isHidden = [
    COMPANY_TYPES.BANK,
    COMPANY_TYPES.NON_BANK,
    COMPANY_TYPES.SECURITIES,
    COMPANY_TYPES.LIFE_INSURANCE,
    COMPANY_TYPES.NON_LIFE_INSURANCE,
  ].includes(companyType)

  return (
    <Element
      style={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        rowGap: '4px',
        columnGap: '12px',
        alignItems: 'center',
      }}
    >
      <DefaultIndustry />
      {!isHidden && <CompareIndustry />}
    </Element>
  )
}
